import { render, staticRenderFns } from "./addReporterToCollection.vue?vue&type=template&id=1aa294ca&scoped=true"
import script from "./addReporterToCollection.vue?vue&type=script&lang=ts"
export * from "./addReporterToCollection.vue?vue&type=script&lang=ts"
import style0 from "./addReporterToCollection.vue?vue&type=style&index=0&id=1aa294ca&prod&lang=scss"
import style1 from "./addReporterToCollection.vue?vue&type=style&index=1&id=1aa294ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa294ca",
  null
  
)

export default component.exports